import React from "react";
import { useTranslation } from "react-i18next";
import { useMoneyCycleData } from "../data/moneyCycle.selectors";
import AnimatedMoneyCycleChart from "./AnimatedMoneyCycleChart";

// Animated Money Cycle Module
const AnimatedMoneyCycleModule = ({ onNavigate }) => {
  const { t } = useTranslation();
  const { data, loading } = useMoneyCycleData();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-400">{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <AnimatedMoneyCycleChart 
        income={data.income || 0}
        expenses={data.expenses || 0}
        savingsMonthly={data.savingsMonthly || 0}
        passiveIncome={data.passiveIncome || data.investmentIncome || 0}
        emergencyFund={data.emergencyFund || 0}
        totalInvestments={data.totalInvestments || 0}
        totalDebt={data.totalDebt || 0}
        debtPayments={data.debtPayments || 0}
        onNavigateToMyNumbers={() => onNavigate && onNavigate('mynumbers')}
      />
    </div>
  );
};

export default AnimatedMoneyCycleModule;
